import React from "react";

import { isEmpty } from "ramda";

import { Pagination, Table } from "components/Common/clearsense-ui/components";
import NoData from "components/Common/NoData";

const MetaIQTable = ({
  totalRequestCount,
  setIsAddNewClassification,
  requests,
  columns,
  setCheckedRows,
  checkedRows,
  filterParams,
}) => {
  const {
    debouncedSearchTerm,
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
  } = filterParams;

  if (!totalRequestCount && isEmpty(debouncedSearchTerm)) {
    return (
      <NoData
        entity="classifications"
        actionLabel="Create Classification"
        onAction={() => setIsAddNewClassification(true)}
      />
    );
  }

  return (
    <div className="flex flex-col h-full mt-4 space-y-6">
      <div className="flex flex-col flex-grow p-2 cs-ui-table-background">
        <Table
          rowData={requests}
          columnData={columns.selected}
          fixedHeight
          allowRowClick={false}
          rowKey={record => record.id}
          onRowSelect={(_, selectedRows) => setCheckedRows(selectedRows)}
          rowSelection={{
            onSelect: (_, __, selectedRows) => setCheckedRows(selectedRows),
            selectedRowKeys: checkedRows.map(row => row.id),
            onSelectAll: () =>
              checkedRows.length === requests.length
                ? setCheckedRows([])
                : setCheckedRows(requests),
          }}
        />
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          showResultsPerPage
          totalRecordsCount={totalRequestCount}
          className="p-8 py-2 mt-auto bg-white"
        />
      </div>
    </div>
  );
};

export default MetaIQTable;
